import { render, staticRenderFns } from "./ochartComponent.vue?vue&type=template&id=017d4c22&scoped=true&"
import script from "./ochartComponent.vue?vue&type=script&lang=js&"
export * from "./ochartComponent.vue?vue&type=script&lang=js&"
import style0 from "./ochartComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../statistics/css/departmentOchart.css?vue&type=style&index=1&id=017d4c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d4c22",
  null
  
)

export default component.exports